import { safeFetch } from "../utils/safeFetch";


export const getAllRuoli = async (token, tenant) => {
  const response = await safeFetch(`/api/roles`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'x-tenant-id': tenant
    }
  }, 'allUsers');

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};

export const createRuolo = async (data, token, tenant) => {
  const response = await safeFetch(`/api/roles`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'x-tenant-id': tenant,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }, 'createRuolo');

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};

export const updateRuolo = async (id, data, token, tenant) => {
  const response = await safeFetch(`/api/roles/${id}`, {
    method: 'PATCH',
    headers: {
      'Authorization': `Bearer ${token}`,
      'x-tenant-id': tenant,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }, 'updateRuolo');

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};

export const deleteRuolo = async (id, token, tenant) => {
  const response = await safeFetch(`/api/roles/${id}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'x-tenant-id': tenant,
    }
  }, 'deleteRuolo');

  if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
  return await response.json();
};
